const hasApprovalValue = (value) => {
  if (value === null || value === undefined || value === false) return false;
  if (value === 0 || value === '0') return false;
  return String(value).trim() !== '';
};

export const normalizeUangType = (item = {}) => {
  if (item.absen_id) return item.absen_id;
  if (item.potongan_id === 3) return 'kasbon';
  if (item.potongan_id === 22) return 'lembur';
  if (item.potongan_id === 11) return 'piket_harian';
  if (item.potongan_id) return 'cicilan';
  return '';
};

export const isUangItem = (item = {}) =>
  ['kasbon', 'cicilan', 'lembur', 'piket_harian', 'piket_perconnote']
    .includes(normalizeUangType(item));

export const isUangFullyApproved = (item = {}) => {
  const type = normalizeUangType(item);

  if (type === 'kasbon' || type === 'cicilan') {
    return hasApprovalValue(item.ttd_direksi);
  }

  if (type === 'lembur' || type === 'piket_harian' || type === 'piket_perconnote') {
    return hasApprovalValue(item.ttd_hc);
  }

  return false;
};

export const isPendingUang = (item = {}) =>
  isUangItem(item) && !isUangFullyApproved(item);
